import React, { useContext } from 'react';
import {
  getInvalidWidgetNumber,
  getInvalidInputMessage
} from '../../../../cabsLandingStateValidator';
import { cabsListingDeepLinkBuilder } from '../../../../cabsListingRequestBuilder';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../../CabsLandingContext';
import { SET_ERROR_MESSAGE, SET_WIDGET } from '../../cabsLandingPageState';
import {
  MOB_CABS_OW_LANDING_SEARCH_CLICK,
  MOB_CABS_RT_LANDING_SEARCH_CLICK,
  MOB_CABS_AT_LANDING_SEARCH_CLICK,
  MOB_CABS_HR_LANDING_SEARCH_CLICK
} from '../../../../constants/omnitureConstants';
import './SearchCabButton.css';

export const SearchButton = () => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const {
    travelFor,
    errorMessage,
    stopOvers,
    sourceCity,
    destinationCity,
    airport,
    airportCity,
    rentalCity,
    selectedDeptDate,
    selectedReturnDate,
    airportRideNow,
    selectedHrPackage,
    trackTemplateEvent
  } = cabsLandingContext;

  const setWidget = widgetNumber => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };

  const setErrorMessage = errorMessage => {
    dispatch &&
      dispatch({ type: SET_ERROR_MESSAGE, newStateValue: errorMessage });
  };

  const showErrorMessage = errorMessage => {
    if (errorMessage != null) {
      setErrorMessage(errorMessage);

      setTimeout(() => {
        setErrorMessage(null);
      }, 2000);
      return true;
    }
  };

  const handleWidgetOpenOnEmptyFields = () => {
    const errorWigdetNumber = getInvalidWidgetNumber({
      travelFor,
      sourceCity,
      destinationCity,
      airport,
      airportCity,
      rentalCity,
      stopOvers
    });

    if (errorWigdetNumber != null) {
      setWidget(errorWigdetNumber);
      return true;
    }
  };

  const handleErrorMessageOnInvalidInput = () => {
    const errorMessageToShow = getInvalidInputMessage({
      travelFor,
      sourceCity,
      destinationCity,
      airport,
      airportCity,
      rentalCity,
      stopOvers
    });
    if (errorMessageToShow != null) {
      if (showErrorMessage(errorMessageToShow)) {
        return true;
      }
    }
    return false;
  };

  const handleInputFieldErrors = (): boolean => {
    if (handleErrorMessageOnInvalidInput()) {
      return true;
    }

    if (handleWidgetOpenOnEmptyFields()) {
      return true;
    }
    return false;
  };

  const onSearchClick = () => {
    if (handleInputFieldErrors()) return;

    const deepLink = cabsListingDeepLinkBuilder({
      travelFor,
      sourceCity,
      destinationCity,
      airport,
      airportCity,
      rentalCity,
      selectedDeptDate,
      selectedReturnDate,
      selectedHrPackage,
      airportRideNow,
      stopOvers
    });
    window.history.pushState(
      { page: '1' },
      'cab landing page',
      window?.location?.href
    );
    // console.log(deepLink)
    deepLink && window.location.replace(deepLink);
  };

  const setOmniture = () => {
    if (travelFor === 'Outstation One-way')
      trackTemplateEvent(MOB_CABS_OW_LANDING_SEARCH_CLICK);
    else if (travelFor === 'Outstation Round-trip')
      trackTemplateEvent(MOB_CABS_RT_LANDING_SEARCH_CLICK);
    else if (travelFor === 'Rentals')
      trackTemplateEvent(MOB_CABS_HR_LANDING_SEARCH_CLICK);
    else trackTemplateEvent(MOB_CABS_AT_LANDING_SEARCH_CLICK);
  };

  return (
    <React.Fragment>
      <button
        onClick={() => {
          onSearchClick();
          setOmniture();
        }}
        className={`fullWidth makeFlex perfectCenter latoBold font16 whiteText searchCabButton`}
      >
        SEARCH CABS
      </button>
      {errorMessage ? (
        <div
          style={{
            borderRadius: '6px',
            padding: '10px 16px',
            margin: '0px 10px'
          }}
          className="greyishBlackBackGroundColor whiteText appendTop10"
        >
          {errorMessage}
        </div>
      ) : null}
    </React.Fragment>
  );
};
